<div class="otp-box" [class.nepal-password-step]="canResetPassword">
  <form [formGroup]="form" style="display: flex; flex-direction: column; gap: 24px" (ngSubmit)="submitted.emit()">
    <div class="form-group">
      <label for="password">Password</label>
      <input [ngClass]="isPasswordVisible ? 'open-password' : 'close-password'"
        [type]="isPasswordVisible ? 'text' : 'password'" style="text-transform: none !important; position: relative"
        id="password" formControlName="password" placeholder="Enter password" autocomplete="current-password" />
      <div class="view-password-btn" (click)="visibilityToggled.emit()"></div>
      @if (errorText) {
      <small class="error-text">{{ errorText }}</small>
      }
    </div>

    <button type="submit" class="verify-btn" [disabled]="isLoading || !form.get('password')?.value">
      @if (isLoading) {
      <span class="spinner" role="status" aria-label="Loading"></span>
      } @else { Login }
    </button>
  </form>

  @if (canResetPassword) {
  <button type="button" class="forgot-password-link" [disabled]="isLoading"
    (click)="forgotPasswordRequested.emit()">Forgot password?</button>
  }

  <div class="resend-text mt-3">
    <span (click)="backed.emit()" class="back">Back</span>
  </div>
</div>
